import { Injectable } from '@angular/core';
import { ModalComponent } from '../../components/modals/modal/modal.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

interface ModalButtonInterface {
  type: string; // ['yellow', 'black', 'gray']
  outline: boolean;
  callback: Observable<any>;
  title: string;
}

interface ModalConfigurationInterface {
  title?: string;
  subtitle?: string;
  content?: string;
  customTitleClass?: string;
  customSubtitleClass?: string;
  customContentClass?: string;
  additionalQRCode?: string;
  eventId?: string;
  token?: string;
  buttons?: Array<ModalButtonInterface>;
  initialCallback?: Function;
  canClose?: boolean;
  onClose?: Observable<any>;
}

@Injectable({
  providedIn: 'any',
})
export class AppModalService {
  constructor(private modalService: NgbModal) {}

  open(config: ModalConfigurationInterface): NgbModalRef {
    if (this.hasAny()) {
      this.dismissAll();
    }

    const modal = this.modalService.open(ModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    modal.componentInstance.content = config.content;
    modal.componentInstance.title = config.title;
    modal.componentInstance.subtitle = config.subtitle;
    modal.componentInstance.buttons = config.buttons;
    modal.componentInstance.customTitleClass = config.customTitleClass;
    modal.componentInstance.customSubtitleClass = config.customSubtitleClass;
    modal.componentInstance.customContentClass = config.customContentClass;
    modal.componentInstance.additionalQRCode = config.additionalQRCode;
    modal.componentInstance.eventId = config.eventId;
    modal.componentInstance.token = config.token;
    modal.componentInstance.modalInitCallback = config.initialCallback
      ? config.initialCallback
      : () => {};
    modal.componentInstance.canClose = config.canClose;
    modal.componentInstance.onClose = config.onClose ? config.onClose : this.defaultCallBack();
    return modal;
  }

  hasAny() {
    return this.modalService.hasOpenModals();
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

  private defaultCallBack() {
    return new Observable((subscriber) => {
      subscriber.next('default callback');
    });
  }
}
